import {
  defaultMqttCombinations,
  defaultMqttTimestamps
} from '@/shared/DefaultValues'
import { Guid } from '@/utils/guid'
import { getFormatMessage } from '@/utils/utils'
import { Form, Input } from 'antd'
import React, { useEffect } from 'react'
import { TemplateEditProps, TemplateItem } from '../interface'

export const TemplateEdit: React.FC<TemplateEditProps> = (
  props: TemplateEditProps
) => {
  const formatMessage = getFormatMessage()
  const [form] = Form.useForm()
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 4 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 }
    }
  }

  useEffect(() => {
    if (props.item) {
      form.setFieldsValue(props.item)
    }
  }, [props.item])

  useEffect(() => {
    if (props.formResult) {
      form
        .validateFields()
        .then((values: TemplateItem) => {
          const merged = Object.assign(props.item, values)
          if (props.onFormValidate) {
            props.onFormValidate(true)
          }
          if (props.onFormSubmit) {
            if (!merged.id) {
              merged.id = Guid.raw()
              merged.combinations = defaultMqttCombinations
              merged.timestamps = defaultMqttTimestamps
            }
            props.onFormSubmit(merged)
            form.resetFields()
          }
        })
        .catch((info) => {
          console.log('Validate Failed:', info)
          if (props.onFormValidate) {
            props.onFormValidate(false)
          }
        })
    }
  }, [props.formResult])

  return (
    <div>
      <Form form={form} {...formItemLayout}>
        <Form.Item
          label={formatMessage({
            id: 'app.template.edit.name'
          })}
          name='name'
          rules={[
            {
              required: true,
              transform: (value) => value?.trim(),
              message: formatMessage({ id: 'app.template.edit.name.message' })
            }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={formatMessage({
            id: 'app.template.edit.remark'
          })}
          name='remark'
        >
          <Input.TextArea />
        </Form.Item>
      </Form>
    </div>
  )
}
